<template>
  <div class="calendar-list-section">
    <ul class="calendar-list-section__list">
      <li
        v-for="(item, index) in calendarData"
        :key="`calendar-list${index}`"
        class="calendar-list-section__item"
      >
        <calendar-item-section :calendarItem="item" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import CalendarItemSection from '@/components/LinkPage/CalendarPane/CalendarItemSection.vue'
import CalendarDataDocument from '@/store/stores/collectionModule/documents/calendar/CalendarDataDocument'

export default defineComponent({
  name: 'CalendarListSection',
  components: { CalendarItemSection },
  props: {
    calendarData: {
      type: Array as PropType<CalendarDataDocument[]>,
      default: () => [],
    },
  },
})
</script>
